/**
 * @fileoverview Barrel exports for template-generator-v2.
 */

export { definition } from './definition';

export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
  type HookInput,
} from './schema';

export { flow, templateGeneratorV2AgentFlow } from './flow';

export { prompt } from './prompt';
